import { render, staticRenderFns } from "./LeftoversChart.vue?vue&type=template&id=034ee428&"
import script from "./LeftoversChart.vue?vue&type=script&lang=js&"
export * from "./LeftoversChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports